/** The Student Dashboard: the signed-in person's classes, course assignments and the redeem box. */
export const studentDashboardPath = '/entitlements/student-dashboard'

/** Current Training: the signed-in person's own, or, under a person's id, theirs for an administrator. */
export const myTrainingPath = '/entitlements/current-training'
export const personTrainingRoute = `${myTrainingPath}/:userId`

/** A person's Current Training, as User Details links to it. */
export function personTrainingPath(userId: string): string {
  return `${myTrainingPath}/${encodeURIComponent(userId)}`
}

/** The API's one call for the signed-in person's training. */
export const myTrainingApi = '/entitlements/v1/me/training'

/** The API's call for a person's training, for an administrator. */
export function personTrainingApi(userId: string): string {
  return `/entitlements/v1/user-profiles/${encodeURIComponent(userId)}/training`
}

/**
 * The Student Dashboard's slots, each given the signed-in person's User Profile as the record.
 * `main`: panels in the main column after Active Course Assignments, such as Classes' week at a
 * glance (CLS-30) and Launch's my labs (LCH-07). `sideTop`: panels at the top of the side column,
 * such as Classes' month calendar (CLS-30). `side`: panels in the side column after Redeem
 * Training Key, such as Credentials' Rewards card (CRD-10). A panel reads the page's one training
 * call through `useStudentTraining`, so it adds none of its own for what that call holds.
 */
export const studentDashboardSlots = {
  main: 'entitlements.student-dashboard.main',
  sideTop: 'entitlements.student-dashboard.side-top',
  side: 'entitlements.student-dashboard.side',
} as const
